/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Space_TypeInputs */

const en_field_space_type = /** @type {(inputs: Field_Space_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Space Type`)
};

const es_field_space_type = /** @type {(inputs: Field_Space_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de espacio`)
};

const fr_field_space_type = /** @type {(inputs: Field_Space_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type d'espace`)
};

const de_field_space_type = /** @type {(inputs: Field_Space_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raumtyp`)
};

const ja_field_space_type = /** @type {(inputs: Field_Space_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スペースの種類`)
};

const zh_field_space_type = /** @type {(inputs: Field_Space_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空间类型`)
};

const ar_field_space_type = /** @type {(inputs: Field_Space_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نوع المساحة`)
};

const id_field_space_type = /** @type {(inputs: Field_Space_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis Ruang`)
};

const it_field_space_type = /** @type {(inputs: Field_Space_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo di Spazio`)
};

const ru_field_space_type = /** @type {(inputs: Field_Space_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип помещения`)
};

const pt_field_space_type = /** @type {(inputs: Field_Space_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de Espaço`)
};

const ko_field_space_type = /** @type {(inputs: Field_Space_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`공간 유형`)
};

/**
* | output |
* | --- |
* | "Space Type" |
*
* @param {Field_Space_TypeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_space_type = /** @type {((inputs?: Field_Space_TypeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Space_TypeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_space_type(inputs)
	if (locale === "es") return es_field_space_type(inputs)
	if (locale === "fr") return fr_field_space_type(inputs)
	if (locale === "de") return de_field_space_type(inputs)
	if (locale === "ja") return ja_field_space_type(inputs)
	if (locale === "zh") return zh_field_space_type(inputs)
	if (locale === "ar") return ar_field_space_type(inputs)
	if (locale === "id") return id_field_space_type(inputs)
	if (locale === "it") return it_field_space_type(inputs)
	if (locale === "ru") return ru_field_space_type(inputs)
	if (locale === "pt") return pt_field_space_type(inputs)
	return ko_field_space_type(inputs)
});